define('SuiteDynamics.CriteoCustomDataLayerFields.CustomerInformation', [
		'underscore',
		'Profile.Model',
		'SuiteDynamics.CriteoCustomDataLayerFields.Utilities',
		'SuiteDynamics.CriteoCustomDataLayerFields.EventProcessor'
	],
	function(
		_,
		ProfileModel,
		Utilities,
		EventProcessor
	)
{
	'use strict';

	function addCustomerInformation(eventData) {
		if (!eventData.data) eventData.data = {};

		var profileModel = ProfileModel.getInstance();
		var additionalEventData = getCustomerInformation(profileModel);

		_.extend(eventData.data, additionalEventData);
	}

	function getCustomerInformation(profileModel) {
		var customerEmail = profileModel.get('email');
		var customerId = profileModel.get('internalid');
		var customerZipcode = getCustomerZipcode(profileModel.get('addressbook'));
		var customerSegment = getCustomerSegment(profileModel);

		if (parseInt(customerId) <= 0) {
			customerId = null;
		}

		return {
			customerEmailSHA256: customerEmail && Utilities.hashSHA256(customerEmail) || '',
			customerEmailMD5: customerEmail && Utilities.hashMD5(customerEmail) || '',
			customerId: customerId && Utilities.hashSHA256(customerId) || '',
			customerZipcode: customerZipcode,
			customerSegment: customerSegment
		};
	}

	function getCustomerZipcode(addressBook) {
		if (!addressBook || !addressBook.length) {
			return '';
		}

		var defaultShippingAddress = _.findWhere(addressBook, { defaultshipping: true });
		var shippingAddress = defaultShippingAddress || addressBook[0];

		return shippingAddress.zip || '';
	}

	function getCustomerSegment(profileModel) {
		var customFields = profileModel.get('customfields');
		var isB2BField = _.findWhere(customFields || [], { name: 'custentity_ano_is_b2b' });

		if (isB2BField && isB2BField.value && isB2BField.value === 'T') {
			return 'B2B';
		}

		return 'B2C';
	}

	var events = ['pageView', 'addToCart', 'cartView', 'homeView', 'productList', 'productListEvent',
		'productView', 'proceedToCheckout', 'transaction'];
	_.each(events, function(event) {
		EventProcessor.registerEventHandler(event, addCustomerInformation);
	});
});
